import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export function FlagIcon(props) {
  return (
    <SvgIcon {...props}>
      <g id="Bounding_Boxes">
        <g id="ui_x5F_spec_x5F_header_copy_3" display="none" />
        <path fill="none" d="M0,0h24v24H0V0z" />
      </g>
      <g id="Duotone">
        <g id="ui_x5F_spec_x5F_header_copy_2" display="none" />
        <g>
          <polygon
            opacity="0.3"
            points="12.36,6 7,6 7,12 14.24,12 14.64,14 18,14 18,8 12.76,8 		"
          />
          <path d="M14.4,6L14,4H5v17h2v-7h5.6l0.4,2h7V6H14.4z M18,14h-3.36l-0.4-2H7V6h5.36l0.4,2H18V14z" />
        </g>
      </g>
    </SvgIcon>
  );
}

export function MineIcon(props) {
  return (
    <SvgIcon {...props}>
      <g id="Bounding_Boxes">
        <g id="ui_x5F_spec_x5F_header_copy_3" />
        <path fill="none" d="M0,0h24v24H0V0z" />
      </g>
      <g id="Duotone">
        <g id="ui_x5F_spec_x5F_header_copy_2" />
        <g>
          <path
            fillOpacity="0.3"
            d="M18,9.52V6h-3.52L12,3.52L9.52,6H6v3.52L3.52,12L6,14.48V18h3.52L12,20.48L14.48,18H18v-3.52L20.48,12
            L18,9.52z M12,18c-3.31,0-6-2.69-6-6s2.69-6,6-6s6,2.69,6,6S15.31,18,12,18z"
          />
          <path
            d="M20,8.69V4h-4.69L12,0.69L8.69,4H4v4.69L0.69,12L4,15.31V20h4.69L12,23.31L15.31,20H20v-4.69L23.31,12L20,8.69z M18,14.48
            V18h-3.52L12,20.48L9.52,18H6v-3.52L3.52,12L6,9.52V6h3.52L12,3.52L14.48,6H18v3.52L20.48,12L18,14.48z"
          />
          <path
            d="M12,6c-3.31,0-6,2.69-6,6s2.69,6,6,6s6-2.69,6-6S15.31,6,12,6z M12,16c-2.21,0-4-1.79-4-4s1.79-4,4-4c2.21,0,4,1.79,4,4
            S14.21,16,12,16z"
          />
          <circle cx="12" cy="12" r="2.5" />
        </g>
      </g>
    </SvgIcon>
  );
}

export function HappyIcon(props) {
  return (
    <SvgIcon {...props}>
      <g id="Bounding_Boxes">
        <g id="ui_x5F_spec_x5F_header_copy_2" />
        <path fill="none" d="M0,0h24v24H0V0z" />
      </g>
      <g id="Duotone">
        <g id="ui_x5F_spec_x5F_header_copy_3" />
        <g>
          <path
            opacity="0.3"
            d="M12,4c-4.42,0-8,3.58-8,8c0,4.42,3.58,8,8,8s8-3.58,8-8C20,7.58,16.42,4,12,4z M15.5,8
			C16.33,8,17,8.67,17,9.5S16.33,11,15.5,11S14,10.33,14,9.5S14.67,8,15.5,8z M8.5,8C9.33,8,10,8.67,10,9.5S9.33,11,8.5,11
			S7,10.33,7,9.5S7.67,8,8.5,8z M12,17.5c-2.33,0-4.32-1.45-5.12-3.5h1.67c0.7,1.19,1.97,2,3.45,2s2.76-0.81,3.45-2h1.67
			C16.32,16.05,14.33,17.5,12,17.5z"
          />
          <circle cx="15.5" cy="9.5" r="1.5" />
          <circle cx="8.5" cy="9.5" r="1.5" />
          <path d="M12,16c-1.48,0-2.75-0.81-3.45-2H6.88c0.8,2.05,2.79,3.5,5.12,3.5s4.32-1.45,5.12-3.5h-1.67C14.76,15.19,13.48,16,12,16z" />
          <path
            d="M11.99,2C6.47,2,2,6.48,2,12c0,5.52,4.47,10,9.99,10C17.52,22,22,17.52,22,12C22,6.48,17.52,2,11.99,2z M12,20
			c-4.42,0-8-3.58-8-8c0-4.42,3.58-8,8-8s8,3.58,8,8C20,16.42,16.42,20,12,20z"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

export function LostIcon(props) {
  return (
    <SvgIcon {...props}>
      <g id="Bounding_Boxes">
        <g id="ui_x5F_spec_x5F_header_copy_2" />
        <path fill="none" d="M0,0h24v24H0V0z" />
      </g>
      <g id="Duotone">
        <g id="ui_x5F_spec_x5F_header_copy" />
        <g>
          <path
            opacity="0.3"
            d="M12,4c-4.42,0-8,3.58-8,8c0,4.42,3.58,8,8,8s8-3.58,8-8C20,7.58,16.42,4,12,4z M6.76,8.82l1.06-1.06
			l1.06,1.06l1.06-1.06L11,8.82L9.94,9.88L11,10.94L9.94,12l-1.06-1.06L7.82,12l-1.06-1.06l1.06-1.06L6.76,8.82z M6.89,17
			c0.8-2.04,2.78-3.5,5.11-3.5s4.31,1.46,5.11,3.5H6.89z M17.24,10.94L16.18,12l-1.06-1.06L14.06,12L13,10.94l1.06-1.06L13,8.82
			l1.06-1.06l1.06,1.06l1.06-1.06l1.06,1.06l-1.06,1.06L17.24,10.94z"
          />
          <path d="M12,13.5c-2.33,0-4.31,1.46-5.11,3.5h10.22C16.31,14.96,14.33,13.5,12,13.5z" />
          <polygon
            points="7.82,12 8.88,10.94 9.94,12 11,10.94 9.94,9.88 11,8.82 9.94,7.76 8.88,8.82 7.82,7.76 6.76,8.82 7.82,9.88 
			6.76,10.94 		"
          />
          <path
            d="M11.99,2C6.47,2,2,6.47,2,12c0,5.53,4.47,10,9.99,10S22,17.53,22,12C22,6.47,17.52,2,11.99,2z M12,20c-4.42,0-8-3.58-8-8
			c0-4.42,3.58-8,8-8s8,3.58,8,8C20,16.42,16.42,20,12,20z"
          />
          <polygon
            points="16.18,7.76 15.12,8.82 14.06,7.76 13,8.82 14.06,9.88 13,10.94 14.06,12 15.12,10.94 16.18,12 17.24,10.94 
			16.18,9.88 17.24,8.82 		"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

export function WonIcon(props) {
  return (
    <SvgIcon {...props}>
      <g id="Bounding_Boxes">
        <g id="ui_x5F_spec_x5F_header_copy_2" />
        <path fill="none" d="M0,0h24v24H0V0z" />
      </g>
      <g id="Duotone">
        <g id="ui_x5F_spec_x5F_header_copy" />
        <g>
          <path
            opacity="0.3"
            d="M12,4c-4.42,0-8,3.58-8,8c0,4.42,3.58,8,8,8s8-3.58,8-8C20,7.58,16.42,4,12,4z M8.88,7.82L11,9.94L9.94,11
          L8.88,9.94L7.82,11L6.76,9.94L8.88,7.82z M12,17.5c-2.33,0-4.31-1.46-5.11-3.5h10.22C16.31,16.04,14.33,17.5,12,17.5z M16.18,11
          l-1.06-1.06L14.06,11L13,9.94l2.12-2.12l2.12,2.12L16.18,11z"
          />
          <polygon points="8.88,9.94 9.94,11 11,9.94 8.88,7.82 6.76,9.94 7.82,11 		" />
          <polygon points="13,9.94 14.06,11 15.12,9.94 16.18,11 17.24,9.94 15.12,7.82 		" />
          <path
            d="M11.99,2C6.47,2,2,6.47,2,12c0,5.53,4.47,10,9.99,10S22,17.53,22,12C22,6.47,17.52,2,11.99,2z M12,20c-4.42,0-8-3.58-8-8
          c0-4.42,3.58-8,8-8s8,3.58,8,8C20,16.42,16.42,20,12,20z"
          />
          <path d="M12,17.5c2.33,0,4.31-1.46,5.11-3.5H6.89C7.69,16.04,9.67,17.5,12,17.5z" />
        </g>
      </g>
    </SvgIcon>
  );
}
